import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import ChangePassword from "./views/ChangePassword.vue";
import WawaAction from "./views/WawaAction.vue";
import SloveOrder from "./views/SloveOrder.vue";
import Index from "./views/Index.vue";
import ActivityCenter from "./views/ActivityCenter.vue";
import NoticeCenter from "./views/NoticeCenter.vue";
import GemDetail from "./views/GemDetail.vue";
import OrderInfo from "./views/OrderInfo.vue";
import PayInfo from "./views/PayInfo.vue";
import Youhuiquan from "./views/Youhuiquan.vue";
import MyOrder from "./views/MyOrder.vue";
import NewsDetail from "./views/NewsDetail.vue";
import Logininfo from "./views/Logininfo.vue";
import GemList from "./views/GemList.vue";
import HealthCenter from "./views/HealthCenter.vue";
import UserCenter from "./views/UserCenter.vue";
import HealthDetail from "./views/HealthDetail.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
    },
    {
      path: "/wawaaction",
      name: "wawaaction",
      component: WawaAction,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/changepassword",
      name: "changepassword",
      component: ChangePassword,
    },
    {
      path: "/sloveorder",
      name: "sloveorder",
      component: SloveOrder,
    },
    {
      path: "/activitycenter",
      name: "activitycenter",
      component: ActivityCenter,
    },
    {
      path: "/noticecenter",
      name: "noticecenter",
      component: NoticeCenter,
    },
    {
      path: "/gemdetail",
      name: "gemdetail",
      component: GemDetail,
    },
    {
      path: "/orderinfo",
      name: "orderinfo",
      component: OrderInfo,
    },
    {
      path: "/payinfo",
      name: "payinfo",
      component: PayInfo,
    },
    {
      path: "/youhuiquan",
      name: "youhuiquan",
      component: Youhuiquan,
    },
    {
      path: "/myorder",
      name: "myorder",
      component: MyOrder,
    },
    {
      path: "/newsdetail",
      name: "newsdetail",
      component: NewsDetail,
    },
    {
      path: "/logininfo",
      name: "logininfo",
      component: Logininfo,
    },
    {
      path: "/gemlist",
      name: "gemlist",
      component: GemList,
    },
    {
      path: "/healthcenter",
      name: "healthcenter",
      component: HealthCenter,
    },
    {
      path: "/usercenter",
      name: "usercenter",
      component: UserCenter,
    },
    {
      path: "/healthdetail",
      name: "healthdetail",
      component: HealthDetail,
    },
  ],
});
